import React from 'react';
import { Link } from 'react-router-dom';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';

const CustomerInformationSheet = () => {
    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Customer Information Sheet</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/employee-dashboard">
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Customer Information Sheet
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>

                <div className="card p-4 shadow-sm">
                    <p><strong>DISCLAIMER NOTE:</strong> The information mentioned below is illustrative and not exhaustive. The information must be read in conjunction with the policy wordings. In case of any conflict between the Customer Information Sheet and the policy wordings, the terms and conditions mentioned in the policy wordings shall prevail.</p>
                    <div className='overflow-x-scroll'>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}>SNo</th>
                                    <th >Title</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Product Name</td>
                                    <td>Group Health (Floater) Insurance</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>What am I Covered for</td>
                                    <td style={{ wordBreak: 'break-word' }}>The policy provides indemnification of medical expenses incurred by the Insured during day care treatment, hospitalization, domiciliary hospitalization, for any illness or injury suffered during the Policy Period.</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Optional Add on Covers</td>
                                    <td>
                                        <ul>
                                            <li>Cover for Pre-Existing Diseases</li>
                                            <li>Maternity Expenses</li>
                                            <li>Out Patient Department (OPD) Expenses</li>
                                            <li>HIV</li>
                                            <li>Cost of Prescribed External Medical Aid</li>
                                            <li>Baby Day One Cover</li>
                                            <li>Critical Illnesses Cover</li>
                                            <li>Travel Expenses For Medical Treatment</li>
                                            <li>Dental Expenses</li>
                                            <li>Cover for Alternate Methods Of Treatment</li>
                                            <li>Donor Expenses</li>
                                            <li>Ambulance Charges</li>
                                            <li>Pre and Post Hospitalization</li>
                                            <li>Health Check-Up</li>
                                            <li>Disease-Wise Sub-Limit</li>
                                            <li>Domiciliary Hospitalization</li>
                                            <li>Treatment Outside India</li>
                                            <li>Convalescence Benefit</li>
                                            <li>Loss of Wages/Salary Due To Hospitalization (Hospital Daily Cash Allowance)</li>
                                            <li>Cover for Allied Hospital Charges</li>
                                            <li>Limit on Room Rent, Nursing Charges, Consultation Fees, Diagnostic Charges, OT Charges etc.</li>
                                            <li>Wellness & Preventive Care</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Waiting Period</td>
                                    <td>
                                        <ul>
                                            <li>Initial Waiting Period</li>
                                            <li>Pre Existing Disease : 1 year</li>
                                            <li>Specific Waiting Periods Maternity Expenses: 9 months</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>What are the major exclusions in the Policy</td>
                                    <td>
                                        <ul>
                                            <li>Pre-Existing Diseases</li>
                                            <li>Circumcision, plastic surgery Cost of spectacles, contact lenses, hearing aids, etc.</li>
                                            <li>Dental treatment or surgery of any kind unless requiring hospitalization.</li>
                                            <li>Convalescence, Sterility, general debility</li>
                                            <li>Intentional self-Injury and use of intoxicating drugs and/or alcohol</li>
                                            <li>Voluntary medical termination of pregnancy during the first 12 weeks from the date of conception</li>
                                            <li>Naturopathy treatment</li>
                                            <li>(Note: the above is a partial listing of the policy exclusions. Please refer to the policy clauses for the full listing)</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Payment Basis</td>
                                    <td>Cashless or Reimbursement claims of covered medical expenses up to specified Sum Insured as per the scope of cover</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>Loss Sharing</td>
                                    <td>
                                        <ul>
                                            <li>In case of a claim, this policy requires you to share the following costs:</li>
                                            <li>Expenses exceeding the sub limits.</li>
                                            <li>Room/ICU Changes</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>8</td>
                                    <td>Renewal Conditions</td>
                                    <td>
                                        <ul>
                                            <li>The Policy can be renewed as a separate contract under the prevailing ICICI Lombard Group Health (Floater) Insurance product or its nearest substitute (in case the product ICICI Lombard Group Health (Floater) Insurance is withdrawn by the Company) approved by IRDA.</li>
                                            <li>The policy shall ordinarily be renewable except on grounds of fraud, moral hazard or misrepresentation or non-cooperation by the insured.</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>9</td>
                                    <td>Cancellation</td>
                                    <td>
                                        <ul>
                                            <li>The Policy shall be void and all premium paid hereon shall be forfeited to the Company, in the event of misrepresentation, misdescription or non-disclosure of any material fact.</li>
                                            <li>Insured or the Company may cancel this Policy by giving the Company or the insured, as the case may be, 15 days written notice for the cancellation of the Policy, and then the Company shall refund premium on short term rates (initiated by the insured) or pro rata rates (if initiated by the Company) for the unexpired Policy Period. The Company shall follow the below short period scale unless otherwise mutually agreed.</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>10</td>
                                    <td>Claims</td>
                                    <td>
                                        <ul>
                                            <li>For Cashless Service: Cashless treatment is only available at our Network Provider. Please refer www@icicilombard.com for updated list of our Network Providers.</li>
                                            <li>For Reimbursement of claim: Claims should be intimated 48 hours prior to Hospitalization or within 24 hours post admission in case of emergency.</li>
                                            <li>Documents to be submitted within 30 days from the date of completion of treatment.</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>11</td>
                                    <td>Policy Servicing/Grievances/Complaints</td>
                                    <td>
                                        <ul>
                                            <li>Call the Company at the toll-free number 1800 266 or email us at customersupport@icicilombard.com</li>
                                            <li>In case the Insured is not satisfied, he/she may approach us at the sub-section "GrievanceRedressal" on www@icicilombard.com. Otherwise, Insured may use IGMS.</li>
                                            <li>If the issue remains unresolved, Insured may approach the Ombudsman.</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr>
                                    <td>12</td>
                                    <td>Insured's Obligations</td>
                                    <td>Disclosure of Material Information during the Policy Period.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>

            </div>
        </div>
    );
};

export default CustomerInformationSheet;
